<template>
  <svg
    v-dompurify-html="svg"
    class="sb-svb-icon"
    data-sb-automation="sb-svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    data-sb-regression="sb-svg-icon"
    v-bind="$attrs"
  />
</template>

<script>
import { buildVueDompurifyHTMLDirective } from 'vue-dompurify-html';

export default {
  name: 'SbSvgIcon',
  directives: {
    dompurifyHtml: buildVueDompurifyHTMLDirective(),
  },
  props: {
    /**
     * Svg element to be rendered.
     * `<svg>...</svg>`
     */
    svg: {
      type: String,
      default: '',
    },
  },
};
</script>
